module.exports = "/static/fonts/fontAwesome.0d2717c.otf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontAwesome.otf
// module id = 796
// module chunks = 2